import { INavigationState } from '../interfaces/inavigation-state';
import { DEFAULT_NAVIGATION_CONFIG } from '../default.menu';

export const NAVIGATION_STATE: INavigationState = {
  config: DEFAULT_NAVIGATION_CONFIG,
  current: null,
};
